import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { Day, DropInApiModel } from 'Public_old/src/app/Services/api/v2/Models/DropInApiModel';
import { SpaContext } from '../../Classes/spacontext';
import { DateService } from '../../Services/date.service';

interface ModifiedDay extends Day {
	isToday: boolean;
	isTomorrow: boolean;
}

interface ModifiedDropIn extends DropInApiModel {
	OpenHours: ModifiedDay[];
}

function isToday(date: string): boolean {
	return new Date(date).setHours(0, 0, 0, 0) === new Date(new Date().AsUTC().setHours(0, 0, 0, 0)).getTime();
}

function isTomorrow(date: string): boolean {
	return new Date(date).setHours(0, 0, 0, 0) === new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime();
}

export module DropInModule {
	export class DropInOpenTimes {
		isToday: boolean;
		isTomorrow: boolean;
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		constructor(public timeslot: any) {}
	}

	export class Room {
		public roomInfo: ModifiedDropIn;

		waitTimeString: string = '';
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		interval: any = null;
		allTimesVisible: boolean = false;
		isInQueue: boolean = false;

		constructor(
			roomInfo: DropInApiModel,
			private translateService: TranslateService,
			private spaContext: SpaContext,
			private dateService: DateService,
		) {
			const { OpenHours, ...noDays } = roomInfo;
			const timeZoneIana = this.spaContext.unitConfig.Locale.TimeZoneIana;

			const modifiedDays: ModifiedDay[] = OpenHours.map((date) => {
				const toZonedDate = (timeStamp: string): string => {
					let str = date.Date.split('T')[0];
					str += `T${timeStamp}`;

					return this.dateService.tz(str, timeZoneIana).local().format('HH:mm');
				};

				const slots = date.Slots.map(({ ClosingTime, OpeningTime }) => {
					return {
						ClosingTime: toZonedDate(ClosingTime),
						OpeningTime: toZonedDate(OpeningTime),
					};
				});

				return {
					...date,
					Slots: slots,
					isToday: isToday(date.Date),
					isTomorrow: isTomorrow(date.Date),
				};
			});

			this.roomInfo = {
				...noDays,
				OpenHours: modifiedDays,
			};
		}

		/**
		 * Countdown
		 */
		public countdown(action: string, name: string) {
			let ti = this.roomInfo.CurrentWaitTime;
			this.getWaitTimeText(ti);
			if (action === 'start') {
				clearInterval(this.interval);
				this.interval = window.setInterval(() => {
					ti--;
					this.getWaitTimeText(ti);
					if (ti < 1) clearInterval(this.interval);
				}, 1000);
			} else if (action === 'stop') {
				clearInterval(this.interval);
			}
		}

		getWaitTimeText(seconds: number) {
			const minutes = Math.floor(seconds / 60);
			let text = minutes + ' ' + this.translateService.get('Common.Abbreviation.MinutesShort');
			if (seconds < this.roomInfo.MinimumShownWaitTime + 1) {
				text =
					'< ' +
					Math.floor(this.roomInfo.MinimumShownWaitTime / 60) +
					' ' +
					this.translateService.get('Common.Abbreviation.MinutesShort');
			} else if (minutes > 59) {
				text =
					Math.floor(minutes / 60) +
					this.translateService.get('Common.Abbreviation.Hours') +
					' ' +
					(minutes % 60) +
					this.translateService.get('Common.Abbreviation.Minutes');
			}

			this.waitTimeString = text;
		}
	}
}
